import React from 'react'
import get from 'lodash/get'
import { getSVG } from '../../helpers/util'

import './Loader.scss'

const loader = getSVG('loader')

const Loader = () => {
  return (
    <div className="LoaderContainer__div">
      <img
        alt="Loader"
        className={
          get(window, '__APP_ENV__.BRAND', '').toLowerCase() === 'dxp'
            ? 'loader'
            : ''
        }
        src={loader}
      />
    </div>
  )
}

Loader.propTypes = {}

Loader.defaultProps = {}

export default Loader
